/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import TimePicker from 'react-bootstrap-time-picker';

const AdvFormTimeSelectItem = React.memo(({ formField, pageData, setPageData }) => {
  const {
    id, value,
  } = formField;
  const handleOnChange = (e) => {
    const updatedPageData = { ...pageData };
    const result = new Date(e * 1000).toISOString().slice(11, 16);
    updatedPageData.formFields[id].value = result;
    setPageData(updatedPageData);
  };

  return (
    <div>
      <div style={{ margin: '5px' }}>
        <TimePicker value={value} onChange={(e) => handleOnChange(e)} format={24} />
      </div>

    </div>
  );
});

export default AdvFormTimeSelectItem;
